module.exports = __webpack_public_path__ + "img/121.4.53372b05.png";